import { Dispatch, SetStateAction, useState } from 'react';
import { ConnectWallet } from './FlipMeBanner';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Withdraw2FARequired } from './WIthdraw2FARequired';

interface FlipMeWalletProps {
  isEarnings?: boolean;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const FlipMeWallet = ({
  step,
  setStep,
  setIsOpen
}: FlipMeWalletProps) => {
  const [walletAddress, setWalletAddress] = useState('');
  return (
    <>
      {step === ConnectWallet.FIRST_STEP && (
        <Step1
          setStep={setStep}
          walletAddress={walletAddress}
          setWalletAddress={setWalletAddress}
        />
      )}

      {step === ConnectWallet.SECOND_STEP && (
        <Step2
          setStep={setStep}
          walletAddress={walletAddress}
          setWalletAddress={setWalletAddress}
        />
      )}

      {step === ConnectWallet.THIRD_STEP && <Step3 setIsOpen={setIsOpen} />}

      {step === ConnectWallet.TWO_FA_REQUIRED && <Withdraw2FARequired />}
    </>
  );
};
